import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { PrePurchaseUserFlow } from "../components/purchaseFlow/PrePurchaseUserFlow";
import { SideImage } from "../components/purchaseFlow/SideImage";
import {
  CONTRACT_TYPES,
  ContractTypeValuesFor,
  PrePurchaseStageKey,
  PRODUCT_TYPES,
  ProductTypes,
  STAGE_TITLES,
} from "../constants/purchaseFlow";

export default function Purchase() {
  const [searchParams, setSearchParams] = useSearchParams();

  // Debugging for email verification flow
  console.log("🔵 Purchase component mounted!");
  console.log("🔵 Current URL:", window.location.href);
  console.log("🔵 Search params:", Object.fromEntries(searchParams.entries()));

  // Get stage from URL parameter
  const stageParam = searchParams.get("stage");
  const validStages = Object.keys(STAGE_TITLES).map(
    Number,
  ) as PrePurchaseStageKey[];

  // Get product from URL parameter
  const productParam = searchParams.get("product");
  const validProducts = PRODUCT_TYPES;

  // Get contract type from URL parameter
  const contractTypeParam = searchParams.get("contractType");
  const validContractTypes = CONTRACT_TYPES;

  // Parse and validate stage
  const parsedStage = stageParam ? parseInt(stageParam) : null;
  const isValidStage =
    parsedStage && validStages.includes(parsedStage as PrePurchaseStageKey);
  const validatedStageURLParam = isValidStage
    ? (parsedStage as PrePurchaseStageKey)
    : 1;

  // Parse and validate product
  const parsedProduct = productParam ? productParam : null;
  const isValidProduct =
    parsedProduct && validProducts.includes(parsedProduct as ProductTypes);
  const validatedProductURLParam = isValidProduct
    ? (parsedProduct as ProductTypes)
    : undefined;

  // Parse and validate contract type
  const parsedContractType = contractTypeParam ? contractTypeParam : null;
  const isValidContractType =
    parsedContractType &&
    validContractTypes.includes(parsedContractType as any);
  const validatedContractTypeURLParam = isValidContractType
    ? (parsedContractType as ContractTypeValuesFor<ProductTypes>)
    : undefined;

  // Handle URL parameter validation and defaults
  useEffect(() => {
    const shouldUpdateStage = !stageParam || !isValidStage;

    if (shouldUpdateStage) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("stage", "1");
      setSearchParams(newParams);
    }
  }, [stageParam, isValidStage, searchParams, setSearchParams]);

  return (
    <div className="w-screen h-screen flex flex-row overflow-hidden">
      <div className="lg:w-1/2 lg:block hidden">
        <SideImage />
      </div>
      <div className="lg:w-1/2 w-full overflow-y-auto h-full">
        <PrePurchaseUserFlow
          stageURLParam={validatedStageURLParam}
          productURLParam={validatedProductURLParam}
          contractTypeURLParam={validatedContractTypeURLParam}
        />
      </div>
    </div>
  );
}
